import { Link } from "react-router-dom";
import { Phone, Home as HomeIcon } from "lucide-react";
import { BUSINESS } from "@/data/site";
import { Seo } from "@/components/site/Seo";
import { PageShell } from "@/components/site/PageShell";

export default function NotFound() {
  return (
    <PageShell>
      <Seo
        title="Page Not Found | Aims Electrical"
        description="Sorry, that page doesn't exist. Head back to the Aims Electrical homepage or get in touch for electrical work across Bradford & West Yorkshire."
        path="/404"
        noindex
      />
      <section className="min-h-[80svh] flex items-center">
        <div className="mx-auto max-w-[1400px] w-full px-6 lg:px-10 py-32">
          <p className="font-mono text-xs tracking-[0.25em] text-brand mb-6">ERROR 404</p>
          <h1 className="font-heading uppercase leading-[0.9] tracking-tight text-5xl sm:text-7xl lg:text-8xl text-stark">
            Page not<br />found<span className="text-brand">.</span>
          </h1>
          <p className="mt-8 text-concrete leading-relaxed max-w-xl text-lg">
            The page you're looking for doesn't exist or has moved. Let's get you back on track — or
            call us directly and we'll help straight away.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-3 bg-brand text-void font-medium px-7 py-4 hover:bg-stark transition-colors duration-200">
              <HomeIcon className="w-5 h-5" strokeWidth={2.5} /> Back to home
            </Link>
            <a href={BUSINESS.phoneHref} className="inline-flex items-center gap-3 border border-hairline text-stark font-medium px-7 py-4 hover:border-brand hover:text-brand transition-colors duration-200">
              <Phone className="w-5 h-5" strokeWidth={2.5} /> {BUSINESS.phoneDisplay}
            </a>
            <Link to="/contact" className="inline-flex items-center gap-3 border border-hairline text-stark font-medium px-7 py-4 hover:border-brand hover:text-brand transition-colors duration-200">
              Contact us
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
